import React from "react";
import PropTypes from 'prop-types';
import {testAttributes} from './Constants';
import GenericPageWithTitle from "../GenericPageWithTitle";
import TopicsFilter from '../../Molecules/TopicsFilter';
import {postGrid} from './LearningCenterPage.module.scss';

const LearningCenterPage = ({ title, description, postsGrid = null, categories = [] }) => (
    <GenericPageWithTitle
        title={title}
        subtitle={description}
        testId={testAttributes.LEARNING_CENTER_LANDING_PAGE}
        topics={categories}
    >
        {categories.length > 0 && <TopicsFilter topics={categories} />}
        {postsGrid && <div key='posts-grid' className={postGrid} data-testid={testAttributes.LEARNING_CENTER_LANDING_PAGE_GRID_CONTAINER}>{postsGrid}</div>}
    </GenericPageWithTitle>
);

LearningCenterPage.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    /** List of posts availables */
    postsGrid: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.any),
            PropTypes.object,
            PropTypes.string,
        ])
    ),
    /** List of categories availables */
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
            isChecked: PropTypes.bool,
            link: PropTypes.string.isRequired,
        })
    ),
};

export default LearningCenterPage;